define('views/conversations/Podio.Views.Conversations.Chat.Main',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/RightPaneMediator','views/conversations/Podio.Views.Conversations.Chat.ListItem','lib/Podio.Router','lib/Podio.Routes','jst!conversations/chat/_main'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var rightPane = require('lib/RightPaneMediator');
  var ConversationsListItemView = require('views/conversations/Podio.Views.Conversations.Chat.ListItem');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');

  var jstMain = require('jst!conversations/chat/_main');

  return PodioView.extend({

    paneIsOpen: false,

    podioEvents: {
      'click default .navigation-container > li' : 'onNavigationItemClicked',
      'click .close-chat-pane-button' : 'onCloseChatPaneButtonClicked'
    },

    initialize: function(options) {
      this._super();
      this.elmContentContainer = $('body');
    },

    render: function() {
      var html = this.getTemplate(jstMain, {
        conversationsUrl: routes.html_conversations_path({format:''}),
        translations: {
          contact_list: t('Contact list #chat.list'),
          all_conversations: t('All conversations #chat.list')
        }
      });
      this.elm.html(html);

      this.elmConversationsList = this.elm.find('.conversation-list-container');
      this.elmDetailsColumn = this.elm.find('.column.details');
    },

    show: function(options) {
      this.paneIsOpen = true;

      var dfd = rightPane.register({
        id: this,
        open: function() {
          this.elmContentContainer.addClass('state-chat-pane-open');
          this.elm.addClass('expanded');

          if (options && options.takeFocus) {
            _.defer(function() {
              this.elm.find('#chat_people_search').focus();
            }.bind(this));
          }
        }.bind(this),
        close: function() {
          this.trigger('chatMainView:closeChatPane');
        }.bind(this)
      });

      dfd.fail(function() {
        this.trigger('chatMainView:closeChatPane');
      }.bind(this));

      return dfd;
    },

    hide: function() {
      if (this.paneIsOpen) {
        this.paneIsOpen = false;

        this.elmContentContainer.removeClass('state-chat-pane-open');
        this.elm.removeClass('expanded');

        return rightPane.unregister({
          id: this
        });
      } else {
        return $.Deferred().resolve();
      }
    },

    showConversationBox: function() {
      this.elmDetailsColumn.addClass('expanded');
    },

    hideConversationBox: function() {
      this.elmDetailsColumn.removeClass('expanded');
    },

    selectNavigationItem: function(navItem) {

      var elmNavigationContainer = this.elm.find('.navigation-container');

      elmNavigationContainer.find('li').removeClass('selected');
      var elmNavItem = elmNavigationContainer.find('li[data-nav-item="{0}"]'.format(navItem));

      elmNavItem.addClass('selected');
    },

    renderPlaceholderNavigationItem: function(conversation) {
      this.destroyPlaceholderNavigationItem();

      this.placeholderConversationView = new ConversationsListItemView({model: conversation, eventBus: this.eventBus});
      this.placeholderConversationView.render();

      var elmTopNavigationContainer = this.elm.find('.navigation-container:first');
      elmTopNavigationContainer.append(this.placeholderConversationView.elm);
    },

    destroyPlaceholderNavigationItem: function() {
      if (this.placeholderConversationView) {
        this.placeholderConversationView.dispose();
        delete this.placeholderConversationView;
      }
    },

    onNavigationItemClicked: function(elmTarget, e) {
      var itemName = elmTarget.data('nav-item');

      if (itemName) {
        e.preventDefault();
        e.stopPropagation();

        this.selectNavigationItem(itemName);
        this.trigger('chatMainView:navigationChanged', itemName);
      }
    },

    onCloseChatPaneButtonClicked: function(elmTarget, e) {
      this.trigger('chatMainView:closeChatPane');
    }
  });

});

